import { z } from 'zod';
import { familyNameSchema } from './auth.js';
import { currencyCodeSchema } from './currency.js';
import { timezoneSchema } from './timezone.js';
export const updateFamilyRequestSchema = z
    .object({
    name: familyNameSchema,
    baseCurrency: currencyCodeSchema,
    timezone: timezoneSchema,
})
    .partial()
    .refine((v) => Object.keys(v).length > 0, 'Nothing to update');
//# sourceMappingURL=family-settings.js.map